import React from "react";
import { Flex } from "@catchoftheday/cg-components";
import { ProductCard } from "@catchoftheday/product-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ProductGrid = function ProductGrid(_ref) {
  var productItems = _ref.productItems,
      lazyLoad = _ref.lazyLoad;
  return ___EmotionJSX(Flex, {
    flexGrow: 1,
    flexWrap: "wrap"
  }, productItems.map(function (productItem, index) {
    return ___EmotionJSX(ProductCard, {
      key: productItem.id,
      lazyLoad: index < 4 ? false : lazyLoad,
      productItem: productItem,
      width: {
        sm: "50%",
        lg: "33%",
        xl: "25%"
      },
      minHeight: "400px",
      height: "auto",
      mb: "20px"
    });
  }));
};